import { floor } from 'lodash'

const QUESTION_SCORE_DISPLAY_PRECISION = 1

export function questionScoreDisplay(score: number) {
  return floor(score, QUESTION_SCORE_DISPLAY_PRECISION)
}
